import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    AMBULANCE_DOCUMENT_USER,
    AMBULANCE_DOCUMENT_CODE_IGSS,
    AMBULANCE_DOCUMENT_PLATES,
    AMBULANCE_DOCUMENT_CHASIS,
    AMBULANCE_DOCUMENT_STATUS_REVIEW,
    AMBULANCE_DOCUMENT_USER_ASSIGNED,
    AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN,
    AMBULANCE_DOCUMENT_LIST,
    AMBULANCE_DOCUMENT_ASSIGN,
    AMBULANCE_DOCUMENT_VALIDATE,
    AMBULANCE_DOCUMENT_SEE_DOCUMENT,
} from "../../actions";

import {
    AmbulanceDocumentUserSuccess,
    AmbulanceDocumentUserError,
    AmbulanceDocumentCodeIgssSuccess,
    AmbulanceDocumentCodeIgssError,
    AmbulanceDocumentPlatesSuccess,
    AmbulanceDocumentPlatesError,
    AmbulanceDocumentChasisSuccess,
    AmbulanceDocumentChasisError,
    AmbulanceDocumentStatusReviewSuccess,
    AmbulanceDocumentStatusReviewError,
    AmbulanceDocumentUserAssignedSuccess,
    AmbulanceDocumentUserAssignedError,
    AmbulanceDocumentUsersForAssignSuccess,
    AmbulanceDocumentUsersForAssignError,
    AmbulanceDocumentListSuccess,
    AmbulanceDocumentListError,
    AmbulanceDocumentAssignSuccess,
    AmbulanceDocumentAssignError,
    AmbulanceDocumentValidateSuccess,
    AmbulanceDocumentValidateError,
    AmbulanceDocumentSeeDocumentSuccess,
    AmbulanceDocumentSeeDocumentError,
    AmbulanceDocumentList,
} from '../../actions';

export function* watchAmbulanceDocumentUser() {
    yield takeEvery(AMBULANCE_DOCUMENT_USER, onAmbulanceDocumentUser);
}
export function* watchAmbulanceDocumentCodeIgss() {
    yield takeEvery(AMBULANCE_DOCUMENT_CODE_IGSS, onAmbulanceDocumentCodeIgss);
}
export function* watchAmbulanceDocumentPlates() {
    yield takeEvery(AMBULANCE_DOCUMENT_PLATES, onAmbulanceDocumentPlates);
}
export function* watchAmbulanceDocumentChasis() {
    yield takeEvery(AMBULANCE_DOCUMENT_CHASIS, onAmbulanceDocumentChasis);
}
export function* watchAmbulanceDocumentStatusReview() {
    yield takeEvery(AMBULANCE_DOCUMENT_STATUS_REVIEW, onAmbulanceDocumentStatusReview);
}
export function* watchAmbulanceDocumentUserAssigned() {
    yield takeEvery(AMBULANCE_DOCUMENT_USER_ASSIGNED, onAmbulanceDocumentUserAssigned);
}
export function* watchAmbulanceDocumentUsersForAssign() {
    yield takeEvery(AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN, onAmbulanceDocumentUsersForAssign);
}
export function* watchAmbulanceDocumentList() {
    yield takeEvery(AMBULANCE_DOCUMENT_LIST, onAmbulanceDocumentList);
}
export function* watchAmbulanceDocumentAssign() {
    yield takeEvery(AMBULANCE_DOCUMENT_ASSIGN, onAmbulanceDocumentAssign);
}
export function* watchAmbulanceDocumentValidate() {
    yield takeEvery(AMBULANCE_DOCUMENT_VALIDATE, onAmbulanceDocumentValidate);
}
export function* watchAmbulanceDocumentSeeDocument() {
    yield takeEvery(AMBULANCE_DOCUMENT_SEE_DOCUMENT, onAmbulanceDocumentSeeDocument);
}

const getToken = async (auth) => {
    return await auth.currentUser.getIdToken(true);
};

const onAmbulanceDocumentUserAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/user', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceDocumentCodeIgssAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/codeigss', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceDocumentPlatesAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/plates', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceDocumentChasisAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/chasis', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceDocumentStatusReviewAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/statusreview', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceDocumentUserAssignedAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/userassigned', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceDocumentUsersForAssignAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/usersforassign', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
    });
    return await response.json();
};

const onAmbulanceDocumentListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify({ page: payload.page, num_page: payload.num_page, filters: payload.filters })
    });
    return await response.json();
};

const onAmbulanceDocumentAssignAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/assign', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify({ data: data })
    });
    return await response.json();
};

const onAmbulanceDocumentValidateAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/validate', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify({ data: data.data, filters: data.filters })
    });
    return await response.json();
};

const onAmbulanceDocumentSeeDocumentAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'ambulanceDocument/seedocument', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify({ id_maintenance_detail: payload.id_maintenance_detail })
    });
    return await response.json();
};

function* onAmbulanceDocumentUser() {
    try {
        const response = yield call(onAmbulanceDocumentUserAsync);
        yield put(AmbulanceDocumentUserSuccess(response));
    } catch (error) {
        yield put(AmbulanceDocumentUserError(error));
    }
}

function* onAmbulanceDocumentCodeIgss() {
    try {
        const response = yield call(onAmbulanceDocumentCodeIgssAsync);
        yield put(AmbulanceDocumentCodeIgssSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceDocumentCodeIgssError(error));
    }
}

function* onAmbulanceDocumentPlates() {
    try {
        const response = yield call(onAmbulanceDocumentPlatesAsync);
        yield put(AmbulanceDocumentPlatesSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceDocumentPlatesError(error));
    }
}

function* onAmbulanceDocumentChasis() {
    try {
        const response = yield call(onAmbulanceDocumentChasisAsync);
        yield put(AmbulanceDocumentChasisSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceDocumentChasisError(error));
    }
}

function* onAmbulanceDocumentStatusReview() {
    try {
        const response = yield call(onAmbulanceDocumentStatusReviewAsync);
        yield put(AmbulanceDocumentStatusReviewSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceDocumentStatusReviewError(error));
    }
}

function* onAmbulanceDocumentUserAssigned() {
    try {
        const response = yield call(onAmbulanceDocumentUserAssignedAsync);
        yield put(AmbulanceDocumentUserAssignedSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceDocumentUserAssignedError(error));
    }
}

function* onAmbulanceDocumentUsersForAssign() {
    try {
        const response = yield call(onAmbulanceDocumentUsersForAssignAsync);
        yield put(AmbulanceDocumentUsersForAssignSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceDocumentUsersForAssignError(error));
    }
}

function* onAmbulanceDocumentList(data) {
    try {
        const response = yield call(onAmbulanceDocumentListAsync, data.payload);
        yield put(AmbulanceDocumentListSuccess(response));
    } catch (error) {
        yield put(AmbulanceDocumentListError(error));
    }
}

function* onAmbulanceDocumentAssign(data) {
    try {
        const response = yield call(onAmbulanceDocumentAssignAsync, data.payload.data);
        if (response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(AmbulanceDocumentAssignSuccess(response));
            yield put(AmbulanceDocumentList(data.payload.page, data.payload.num_page, data.payload.header, data.payload.filters));
        } else {
            NotificationManager.error(response.message, 'Error', 3000, null, null, '');
            yield put(AmbulanceDocumentAssignError(response.message));
        }
    } catch (error) {
        NotificationManager.error('Error al asignar', 'Error', 3000, null, null, '');
        yield put(AmbulanceDocumentAssignError(error));
    }
}

function* onAmbulanceDocumentValidate(data) {
    try {
        const response = yield call(onAmbulanceDocumentValidateAsync, data.payload);
        if (response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(AmbulanceDocumentValidateSuccess(response));
            yield put(AmbulanceDocumentList(data.payload.page, data.payload.num_page, data.payload.header, data.payload.filters));
        } else {
            NotificationManager.error(response.message, 'Error', 3000, null, null, '');
            yield put(AmbulanceDocumentValidateError(response.message));
        }
    } catch (error) {
        NotificationManager.error('Error al validar', 'Error', 3000, null, null, '');
        yield put(AmbulanceDocumentValidateError(error));
    }
}

function* onAmbulanceDocumentSeeDocument(data) {
    try {
        const response = yield call(onAmbulanceDocumentSeeDocumentAsync, data.payload);
        yield put(AmbulanceDocumentSeeDocumentSuccess(response.data));
    } catch (error) {
        yield put(AmbulanceDocumentSeeDocumentError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchAmbulanceDocumentUser),
        fork(watchAmbulanceDocumentCodeIgss),
        fork(watchAmbulanceDocumentPlates),
        fork(watchAmbulanceDocumentChasis),
        fork(watchAmbulanceDocumentStatusReview),
        fork(watchAmbulanceDocumentUserAssigned),
        fork(watchAmbulanceDocumentUsersForAssign),
        fork(watchAmbulanceDocumentList),
        fork(watchAmbulanceDocumentAssign),
        fork(watchAmbulanceDocumentValidate),
        fork(watchAmbulanceDocumentSeeDocument),
    ]);
}
